<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">
      <!-- Elements -->
      <div class="row">
        <div class="col-12 col-12-medium col-6-large content-column">


          @if (isLoading) {
          <div>
            <div class="spinner-container">
              <div class="spinner"></div>
            </div>
            <h5>Retrieving data...</h5>
          </div>
          }

          @if (!isLoading) {
          <div>
            <h3>{{bootcamp?.productTitle}}</h3>
            <div class="details-container">
              <div class="item">
                <p><b><u>{{bootcamp?.location}}</u></b></p>
                <p><b>{{bootcamp?.eventDate}}</b></p>
                <p>{{bootcamp?.time}}</p>
                <p>{{bootcamp?.street}}</p>
                <p>{{bootcamp?.city}}, {{bootcamp?.state}}, {{bootcamp?.zip}}</p>
                <p>{{ bootcamp?.amount | currency }}</p>
                <br>
                @if (bootcamp?.product_descriptions?.length) {
                <div class="class-details">
                  <h5><b>Description</b></h5>
                  @for (desc of bootcamp?.product_descriptions; track desc) {
                  <p>{{ desc.description }}</p>
                  }
                  <br>
                </div>
                }
                @if (bootcamp?.topics?.length) {
                <div class="class-details">
                  <h5><b>Topics</b></h5>
                  <ul class="topics-list">
                    @for (topic of bootcamp?.topics; track topic) {
                    <li>{{ topic.topic }}</li>
                    }
                  </ul>
                </div>
                }
                @if (bootcamp?.detailedDescription) {
                <div class="class-details">
                  <h5><b>Class Overview</b></h5>
                  <p>{{ bootcamp?.detailedDescription }}</p>
                </div>
                }
                @if (bootcamp?.results?.length) {
                <div class="class-details">
                  <h5><b>What You'll Learn</b></h5>
                  <ul class="results-list">
                    @for (result of bootcamp?.results; track result) {
                    <li>{{ result }}</li>
                    }
                  </ul>
                </div>
                }

                <!-- Map placed here on mobile (below 768px) -->
                <div class="map-section map-mobile">
                  <h5><b>Map</b></h5>
                  @if (bootcamp?.mapURL) {
                  <span class="image fit">
                    <iframe [src]="bootcamp?.mapURL | safeUrl" width="256" class="map-iframe" style="border:0;"
                      allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </span>
                  }
                </div>

                @if (bootcamp?.coupons?.length) {
                <div class="class-details">
                  <h5><b>$10 Off Coupon</b></h5>
                  @for (coupon of bootcamp?.coupons; track coupon) {
                  <p>
                    <strong>Code:</strong> {{ coupon.coupon_code }}<br>
                    <strong>Expires:</strong> {{ coupon.coupon_expiration }}
                  </p>
                  }
                  <br>
                  <p><b>Instructions: </b></p>
                  <p>Enter code via the "Add Code" button on the purchase page before expiration date.</p>
                </div>
                }
                <div class="btn-container">
                  <button class="purchase-btn" (click)="initiateCheckout(bootcamp?.priceID)"
                    [disabled]="isInitiatingCheckout || !bootcamp?.priceID">
                    @if (!isInitiatingCheckout) {
                    <span>Register</span>
                    }
                    @if (isInitiatingCheckout) {
                    <span class="checkout-spinner"></span>
                    }
                  </button>
                  <span><a (click)="goBack()" class="back-link">Go Back</a></span>
                </div>
              </div>
              <br>
            </div>
          </div>
          }

        </div>

        <!-- Map column for desktop (above 768px) -->
        <div class="col-12 col-12-medium col-6-large map-column">
          <div class="map-section map-desktop">
            <h3>Map</h3>
            @if (bootcamp?.mapURL) {
            <span class="image fit">
              <iframe [src]="bootcamp?.mapURL | safeUrl" width="256" class="map-iframe" style="border:0;"
                allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>